export function SpotlightGraphics() {
  return (
    <div
      className="pointer-events-none absolute left-1/2 top-9 -translate-x-1/2 bg-gradient-to-l from-[rgba(155,108,255,0.9)] via-[rgba(155,108,255,0.35)] to-[rgba(36,0,116,0)] blur-[20px]"
      style={{
        width: '359px',
        height: '123px',
        transform: 'translate(-50%, 0) rotate(236deg)',
        willChange: 'filter',
        animation: 'breathe 5s ease-in-out infinite',
      }}
    />
  )
}
